// Centralized responsive breakpoint system
// All breakpoint values and media query helpers in one place

// Raw breakpoint values (in px)
export const breakpointValues = {
  xs: 0,
  sm: 480,
  md: 768,
  lg: 1024,
  xl: 1200,
  xxl: 1440,
};

// Media query helpers for styled-components
// Usage: ${media.md} { flex-direction: column; }
export const media = {
  xs: `@media (max-width: ${breakpointValues.sm - 1}px)`,     // 0–479px   (small phones)
  sm: `@media (max-width: ${breakpointValues.md - 1}px)`,     // 0–767px   (phones)
  md: `@media (max-width: ${breakpointValues.lg - 1}px)`,     // 0–1023px  (tablets)
  lg: `@media (max-width: ${breakpointValues.xl - 1}px)`,     // 0–1199px  (small laptops)
  xl: `@media (max-width: ${breakpointValues.xxl - 1}px)`,    // 0–1439px  (laptops)
};

// Min-width (mobile-first) helpers
// Usage: ${mediaUp.md} { display: grid; }
export const mediaUp = {
  sm: `@media (min-width: ${breakpointValues.sm}px)`,         // 480px+
  md: `@media (min-width: ${breakpointValues.md}px)`,         // 768px+
  lg: `@media (min-width: ${breakpointValues.lg}px)`,         // 1024px+
  xl: `@media (min-width: ${breakpointValues.xl}px)`,         // 1200px+
  xxl: `@media (min-width: ${breakpointValues.xxl}px)`,       // 1440px+
};

// Responsive spacing - smaller on mobile
export const responsiveSpacing = {
  pagePadding: {
    mobile: '12px',
    tablet: '16px',
    desktop: '24px',
  },
  sectionGap: {
    mobile: '12px',
    tablet: '16px',
    desktop: '24px',
  },
  cardPadding: {
    mobile: '12px',
    tablet: '16px',
    desktop: '20px',
  },
};

// Layout constants
export const layout = {
  sidebarWidth: '220px',
  sidebarCollapsedWidth: '0px',
  headerHeight: '56px',
  mobileHeaderHeight: '52px',
  bottomNavHeight: '56px',
};
